import { createStore } from "vuex";

export default createStore({
    state: {
        user: null,
    },
    getters: {},
    mutations: {
        SET_CURRENT_USER(state, currentUser) {
            state.user = currentUser;
        },
    },
    actions: {
        setCurrentUser({ commit }, currentUser) {
            commit("SET_CURRENT_USER", currentUser);
        },
    },
    modules: {},
});
